import React from 'react'
import { Link } from 'react-router'
import {List, ListItem} from 'material-ui/List'
import * as R from 'ramda'


import Divider from 'material-ui/Divider'



export default (o) => {
	let scrollPos = 0
	return(
		<div
			id="main-content"
			style={{
				marginLeft: (typeof global.md.phone() == 'string')?
						"0"
					: '54px'
			  , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"0px":"60px"
			  , overflow: 'hidden'
			  , height: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?'calc(100vh - 60px)': (typeof global.md.tablet() == "string")? 'calc(100vh - 168px)' : 'calc(100vh - 109px)'
			  , width: (o.rightStackOpened)? (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?  "100%" : "calc(53% - 53px)" : `calc(100% - ${(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "0px" : "53px"})`
			}}
			onScroll={(evt)=>{
				// if(scrollPos < evt.target.scrollTop){
				// 	if(o.filters) o.toggleFilt()
				// }else if(evt.target.scrollTop < 0){
				// 	console.log("need to open")
				// }
			}}
			speed={0.8}
			className="area"
			contentClassName="content"
			horizontal={false}
			verticalScrollbarStyle={{
				width: "16px"
			  , borderRadius: "13px"
			  , marginLeft: "1px"
			  , backgroundImage: "url(/assets/manager/img/bar.png)"
			  , backgroundSize: "100%"
			  , backgroundRepeat: "no-repeat"
			  , backgroundColor: "#f5f6f5"
			  , backgroundPosition: "center"
			  , display: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "none" :"auto"
			}}
			minScrollSize={30}
			verticalContainerStyle={{
				width: "18px"
			  , backgroundColor: "#cdcdcd"
			  , opacity: "1 !important"
			  , display: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "none" :"auto"
			}}
		>
		{(typeof global.md.phone() != 'string')?
			<div
				style={{
					fontSize: "20px"
				  , marginTop: "31px"
				  , color: "#FFF"
				  , position: "fixed"
				  , zIndex: "1000"
				  , top: "-15px"
				  , left: "76px"
				}}
			>
				Templates
			</div>
			: ""
		}
		<List
			style={{
				backgroundColor: "transparent"
			  , marginTop: "0"
			  , marginLeft: "-2px"
			}}
		>
		{
			(R.keys(o.templates).length)?
				R.map((template) => (
					<Link
						to={`/manager/templates/${template._id}`}
						key={`project-${template._id}`}
						className="ent-card repairman-card"
						style={{
							display: "block"
						}}
					>
						<ListItem
							key={`project-${template._id}`}
							style={{
								height: "79px"
							  , backgroundColor: (o.lastInteracted == o.id)? "#E8E8E8": "#FFF"
							  , overflow: 'hidden'
							  , paddingLeft: "0"
							  , marginLeft: (typeof global.md.phone() != 'string')?"0":undefined
							  , border: "1px solid #e1e3e2"
							  , margin: "0"
							}}
						>
							<img
								src={"/manager/static/img/templates_green.png"}
								style={{
									marginTop: "14px"
								  , marginLeft: "8px"
								  , marginRight: "20px"
								  , height: "auto"
								  , width: "18px"
								  , float: "left"
								}}
							/>
							<p
								style={{
									marginLeft: "16px"
								  , marginTop: "16px"
								  , fontSize: "16px"
								  , fontWeight: "bold"
								  , width: "80%"
								  , overflow: "hidden"
								  , textOverflow: "ellipsis"
								}}
							>
								{template.title}
							</p>
						</ListItem>
					</Link>
				), R.values(o.templates))
				: 'Nothing'
	    }
		</List>

		</div>
	)
}



// WEBPACK FOOTER //
// ./src/routes/manager/templates/TemplatesList.js